import * as React from "react";
import {createStyles, Theme, WithStyles, withStyles} from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import autobind from "autobind-decorator";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import Autosuggest from 'react-autosuggest';
import Popper from "@material-ui/core/Popper/Popper";
import Paper from "@material-ui/core/Paper/Paper";
import {withI18n, WithI18n} from "../../core/i18n/withI18n";
import {compose} from "redux";
// tslint:disable: no-empty
const styles = (t: Theme) => createStyles({
  container: {
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 9999,
    marginTop: t.spacing.unit,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
});

interface IState {
  value: string;
  suggestions: string[],
  hasBeenClicked: boolean;
}

interface IProps extends
  WithI18n,
  WithStyles<typeof styles> {
  onChange: (value) => any;
  data: any[];
  withoutFilter: boolean;
  resetOnSelect: boolean;
  onSelect: (value) => any;
  id: string;
  placeholder: string;
  label: string;
}

const renderInputComponent = inputProps => {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node)
        },
        classes: {
          input: classes.input
        }
      }}
      {...other}
    />
  )
};

function getSuggestions(value, data, withoutFilter): any {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  if(inputLength === 0 || !data || data === [])
    return [];
  else if(withoutFilter){
    return data.filter(d => {
      const keep = count < 5;
      if(keep)
        count += 1;
      return keep;
    })
  } else {
    return data.filter(d => {
      const keep =
        count < 5 && d.label.toLowerCase().slice(0, inputLength) === inputValue;
      if(keep)
        count += 1;
      return keep;
    })
  }
}

function getSuggestionValue(suggestion) {
  return suggestion.label;
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  if(suggestion){
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);
    return (
      <MenuItem selected={isHighlighted} component="div">
        <div>
          {parts.map((part, index) => {
            return part.highlight ? (
              <span key={String(index)} style={{ fontWeight: 500 }}>
              {part.text}
            </span>
            ) : (
              <strong key={String(index)} style={{ fontWeight: 300 }}>
                {part.text}
              </strong>
            );
          })}
        </div>
      </MenuItem>
    );
  } else return "";
}

class InputAutocomplete extends React.Component<IProps, IState> {

  state = {
    value: '',
    suggestions: [],
    hasBeenClicked: false
  };

  popperNode: any;

  componentDidUpdate(prevProps){
    if(JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data) && !this.state.hasBeenClicked){
      this.handleSuggestionsFetchRequested({value: this.state.value})
    }
  }

  render(){
    const { classes, t, onSelect, id, placeholder, label } = this.props;

    return (
      <div>
        <Autosuggest
          onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
          suggestions={this.state.suggestions}
          renderInputComponent={renderInputComponent}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={{
            classes,
            ...label && {label},
            placeholder: placeholder || t.search_placeholder,
            value: this.state.value,
            onChange: this.handleChange,
            inputRef: node => {
              this.popperNode = node;
            },
            InputLabelProps: {
              shrink: true,
            },
            ...id && {id}
          }}
          theme={{
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
          }}
          renderSuggestionsContainer={options => (
            <Popper
              anchorEl={this.popperNode}
              open={Boolean(options.children)}
              style={{
                zIndex: 1400
              }}
            >
              <Paper
                square
                {...options.containerProps}
                style={{ width: this.popperNode ? this.popperNode.clientWidth : null }}
              >
                {options.children}
              </Paper>
            </Popper>
          )}
          {...onSelect && {
            onSuggestionSelected: this.onSelect
          }}
          {...id && {id}}
        />
      </div>
    )
  }

  @autobind
  private handleChange(e, {newValue}){
    this.setState({value: newValue})
  }

  @autobind
  private handleSuggestionsFetchRequested({value}){
    const { data, withoutFilter } = this.props;
    if(this.props.onChange) this.props.onChange(value);
    this.setState({
      suggestions: getSuggestions(value, data, withoutFilter)
    })
  }

  @autobind
  private handleSuggestionsClearRequested(){
    this.setState({
      suggestions: [],
    });
  }

  @autobind
  private onSelect(event, {suggestion}){
    this.props.onSelect(suggestion);
    this.setState({hasBeenClicked: true});
    if(this.props.resetOnSelect){
      this.setState({
        value: '',
        suggestions: []
      });
      this.forceUpdate();
    }
  }
}

export default compose(
  withI18n,
  withStyles(styles)
)(InputAutocomplete);



// WEBPACK FOOTER //
// ./src/shared/InputAutocomplete/InputAutocomplete.tsx